import { connect } from '@ardoq/rxbeach';
import { fileOptions$ } from 'scopeData/editors/file/fileOptions';
import { List } from '../List';

const FileSelector = connect(List, fileOptions$);

export { FileSelector };
